import { EquipmentModel } from '../../interfaces/equipment.interface';
import { InterimModel } from '../../interfaces/interim.interface';

export type ProtocolState = Readonly<{
    user: string;
    material: string;
    serialNo: string;
    orderNo: string;
    equipments: EquipmentModel[];
    interims: InterimModel[];
    isLoading: boolean;
}>;

export const initialProtocolsState: ProtocolState = {
    user: '',
    material: '',
    serialNo: '',
    orderNo: '',
    equipments: [],
    interims: [],
    isLoading: false,
};
